<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">نقش ها</h3>
        </div>
        <div class="card-body" style="direction: rtl">
            <CTabs>
                <CTab title="مدیریت" active>
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">مدیریت</h3>
                        </CCardHeader>
                        <CCardBody>
                            <CDataTable
                                :hover="true"
                                :border="true"
                                :striped="true"
                                :small="true"
                                :items="Permissions.management"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Admin',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />

                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                    

                </CTab>
                <CTab title="برخط" >
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">برخط</h3>
                        </CCardHeader>
                        <CCardBody>
                             <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.online"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Map',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                    
                </CTab>
                <CTab title="گزارشات" >
<br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">گزارشات</h3>
                        </CCardHeader>
                        <CCardBody>
                            <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.report"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Report',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                     
                </CTab>
                <CTab title="پرداخت">
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">پرداخت</h3>
                        </CCardHeader>
                        <CCardBody>
                            <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.pay"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Payment',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                     
                </CTab>
                <CTab title="تنظیمات امنیتی">
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">مدیریت</h3>
                        </CCardHeader>
                        <CCardBody>
                            <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.security"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('SecurtSettings',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                    
                </CTab>
                <CTab title="تعرفه">
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">تعرفه</h3>
                        </CCardHeader>
                        <CCardBody>
                            <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.tariff"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Tariff',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                     
                </CTab>
                <CTab title="نیاز به بررسی">
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">نیاز به بررسی</h3>
                        </CCardHeader>
                        <CCardBody>
                             <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.bogs"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Bugs',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                    
                </CTab>
                <CTab title="بازرسی">
                    <br>
                    <CCard>
                        <CCardHeader>
                            <h3 class="card-title">بازرسی</h3>
                        </CCardHeader>
                        <CCardBody>
                            <CDataTable
                                :hover="true"
                                :border="true"
                                
                                :striped="true"
                                :small="true"
                                :items="Permissions.violations"
                                :fields="fields"
                                :fixed="true"
                                :clickableRows="true"
                                :items-per-page="20"
                                pagination
                                style="overflow: hidden;margin-top:10px"
                                >
                                <template #Rows="{index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #Access="{item,index}">
                                    <td>
                                        <input v-if="CHeckAccess('Violation',index)" style="margin:0 auto;width: 30px;" type="checkbox" id="checkbox" v-model="item.Access" />
                                        <input v-else style="margin:0 auto;width: 30px;" disabled type="checkbox" id="checkbox" v-model="item.Access" />
                                    </td>
                                </template>
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                            <CButton color="primary" @click="UpdatePermission()">
                                به روزرسانی
                            </CButton>
                        </CCardFooter>
                    </CCard>
                     
                </CTab>
            </CTabs>
            <!-- <CDataTable
                :hover="true"
                :border="true"
                
                :striped="true"
                :small="true"
                :items="$store.state.Rules_GetAll"
                :fields="fields"
                :fixed="true"
                :clickableRows="true"
                :items-per-page="7"
                pagination
                style="overflow: hidden;margin-top:10px"
                >
                <template #Rows="{item,index}">
                    <td style="direction: ltr">
                        {{index+1 }}
                    </td>
                </template>
                <template #View="{item,index}">
                    <td style="direction: ltr">
                        <CButton color="primary"  @click="View()">
                                    مشاهده
                        </CButton>
                    </td>
                </template>



            </CDataTable> -->
        </div>
        <!-- <div class="card-footer">

        </div> -->
    </div>
</template>

<script>
    export default {
        name: "Pages",
        data(){
            return{
                fields:[{key:'Rows',label:'ردیف'},{key:'name',label:'عنوان'},{key:'Access',label:'دسترسی'}],
                
                Permissions:{
                    management:[
                        {name:"تخصیص دستگاه",key:"allocation",Access:false,disabled:false},
                        {name:"تخصیص به شرکت",key:"companyAssign",Access:false,disabled:false},
                        {name:"مدیریت دستگاه ها",key:"devices",Access:false,disabled:false},
                        {name:"مدیریت خودرو ها",key:"vehicles",Access:false,disabled:false},
                        {name:"مدیریت رانندگان",key:"drivers",Access:false,disabled:false},
                        {name:"شرکت ها",key:"companies",Access:false,disabled:false},
                        {name:"مدیریت کاربران",key:"users",Access:false,disabled:false},
                        {name:"مدیریت خط",key:"fleets",Access:false,disabled:false},
                        {name:"تخصیص دسترسی به خط",key:"fleets_allocation",Access:false,disabled:false},
                        {name:"پیکربندی دستگاه ها",key:"device_configuration",Access:false,disabled:true},
                        
                    ],
                    online:[
                        {name:"نقشه",key:"map",Access:false,disabled:false},
                        {name:"کنترل نقشه",key:"control",Access:false,disabled:false},
                        {name:"تاریخچه نقشه",key:"history",Access:false,disabled:false},
                        {name:"کنترل خطوط",key:"lineControl",Access:false,disabled:false},
                        {name:"اعلان ها",key:"Alarm",Access:false,disabled:false},
                    ],
                    report:[
                        {name:"کارکرد خط",key:"function",Access:false,disabled:false},
                        {name:"کارکرد خودرو",key:"vehicle",Access:false,disabled:false},
                        {name:"توقف",key:"stop",Access:false,disabled:false},
                        {name:"پارک",key:"park",Access:false,disabled:false},
                        {name:"نقشه",key:"map",Access:false,disabled:false},
                        {name:"خط",key:"line",Access:false,disabled:false},
                        {name:"جابجایی خط",key:"FleetMove",Access:false,disabled:false},
                        {name:"گزارش کلی خط",key:"FullFunction",Access:false,disabled:false},
                        {name:"کارکرد کل خط",key:"TotalFunction",Access:false,disabled:false},
                        {name:"تردد در ایستگاه",key:"StationHistory",Access:false,disabled:false},
                        {name:"اطلاعات خط",key:"FleetsInformation",Access:false,disabled:false},
                        {name:"تخلفات",key:"Violations",Access:false,disabled:false},
                        {name:"کراپ  نقشه",key:"crop",Access:false,disabled:false},
                        {name:"سیپاد",key:"Sipaad",Access:false,disabled:false},
                    ],
                    pay:[
                        {name:"تراکنش ها",key:"transaction",Access:false,disabled:true},
                        {name:"گزارش مالی",key:"financial",Access:false,disabled:true},
                        {name:"پذیرندگان",key:"merchant",Access:false,disabled:true},
                        {name:"کارت",key:"cart",Access:false,disabled:true},
                    ],
                    security:[
                        {name:"نقش ها",key:"roles",Access:false,disabled:false},
                        {name:"تنظیمات صفحه",key:"page",Access:false,disabled:true},
                        {name:"تغییر پروفایل",key:"profile",Access:false,disabled:true},
                        {name:"تغییر کلمه عبور",key:"password_change",Access:false,disabled:true},
                        
                    ],
                    tariff:[
                        {name:"جدول تعرفه",key:"tariff",Access:false,disabled:false},
                        {name:"تقویم",key:"calender",Access:false,disabled:false},
                        {name:"جدول اولویت",key:"devices",Access:false,disabled:false},
                        {name:"تعرفه خط",key:"fleets",Access:false,disabled:false},
                        {name:"عنوان روز",key:"days",Access:false,disabled:false},
                    ],
                    bogs:[
                        {name:"اطلاعات مسیر خط",key:"FleetInformation",Access:false,disabled:true},
                        {name:"سیپاد",key:"FleetInformation",Access:false,disabled:true},
                        
                    ],
                    violations:[
                        {name:"ثبت",key:"Add",Access:false,disabled:false},
                        {name:"تعاریف",key:"Defines",Access:false,disabled:false},
                    ]
                },
                Permission:{},
            }
        },
        computed:{
            ReadRules_Get(){
                return this.$store.state.Rules_Get.RequestResponse;
            },
            ReadRulesPermission_Update(){
                return this.$store.state.RulesPermission_Update;
            }
        },
        watch:{
            ReadRules_Get(data){
                console.log(data)
                if(data.length>0){
                    console.log(data[0])
                    this.ParsePermission(data[0])
                }
            },
            ReadRulesPermission_Update(res){
                if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse[0].Message==='Successfully!'){
                            
                            this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                        }
                        
                    }
                    
                }
            }
        },
        mounted(){
            this.Permission=this.$session.get("Permission");
            this.Rules_Get(this.$route.query.RoleID);
        },
        methods:{
            Rules_Get(id){
                this.$store.commit('Rules_Get',{
                    Rules_ID:id
                });
            },
            ParsePermission(item){
               //management
               this.Permissions.management[0].Access=(((item.Admin) & 0x01)===0x01);
               this.Permissions.management[1].Access=(((item.Admin>>1) & 0x01)===0x01);
               this.Permissions.management[2].Access=(((item.Admin>>2) & 0x01)===0x01);
               this.Permissions.management[3].Access=(((item.Admin>>3) & 0x01)===0x01);
               this.Permissions.management[4].Access=(((item.Admin>>4) & 0x01)===0x01);
               this.Permissions.management[5].Access=(((item.Admin>>5) & 0x01)===0x01);
               this.Permissions.management[6].Access=(((item.Admin>>6) & 0x01)===0x01);
               this.Permissions.management[7].Access=(((item.Admin>>7) & 0x01)===0x01);
               this.Permissions.management[8].Access=(((item.Admin>>8) & 0x01)===0x01);
               this.Permissions.management[9].Access=(((item.Admin>>9) & 0x01)===0x01);
               //online
               this.Permissions.online[0].Access=(((item.Map>>0) & 0x01)===0x01);
               this.Permissions.online[1].Access=(((item.Map>>1) & 0x01)===0x01);
               this.Permissions.online[2].Access=(((item.Map>>2) & 0x01)===0x01);
               this.Permissions.online[3].Access=(((item.Map>>3) & 0x01)===0x01);
               this.Permissions.online[4].Access=(((item.Map>>4) & 0x01)===0x01);
               //report
               this.Permissions.report[0].Access=(((item.Report>>0) & 0x01)===0x01);
               this.Permissions.report[1].Access=(((item.Report>>1) & 0x01)===0x01);
               this.Permissions.report[2].Access=(((item.Report>>2) & 0x01)===0x01);
               this.Permissions.report[3].Access=(((item.Report>>3) & 0x01)===0x01);
               this.Permissions.report[4].Access=(((item.Report>>4) & 0x01)===0x01);
               this.Permissions.report[5].Access=(((item.Report>>5) & 0x01)===0x01);
               this.Permissions.report[6].Access=(((item.Report>>6) & 0x01)===0x01);
               this.Permissions.report[7].Access=(((item.Report>>7) & 0x01)===0x01);
               this.Permissions.report[8].Access=(((item.Report>>8) & 0x01)===0x01);
               this.Permissions.report[9].Access=(((item.Report>>9) & 0x01)===0x01);
               this.Permissions.report[10].Access=(((item.Report>>10) & 0x01)===0x01);
               this.Permissions.report[11].Access=(((item.Report>>11) & 0x01)===0x01);
               this.Permissions.report[12].Access=(((item.Report>>12) & 0x01)===0x01);
               this.Permissions.report[13].Access=(((item.Report>>13) & 0x01)===0x01);
                //Payment
               this.Permissions.pay[0].Access=(((item.Payment>>0) & 0x01)===0x01);
               this.Permissions.pay[1].Access=(((item.Payment>>1) & 0x01)===0x01);
               this.Permissions.pay[2].Access=(((item.Payment>>2) & 0x01)===0x01);
               this.Permissions.pay[3].Access=(((item.Payment>>3) & 0x01)===0x01);
                //security
               this.Permissions.security[0].Access=(((item.SecurtSettings>>0) & 0x01)===0x01);
               this.Permissions.security[1].Access=(((item.SecurtSettings>>1) & 0x01)===0x01);
               this.Permissions.security[2].Access=(((item.SecurtSettings>>2) & 0x01)===0x01);
               this.Permissions.security[3].Access=(((item.SecurtSettings>>3) & 0x01)===0x01);
                //Tariff
               this.Permissions.tariff[0].Access=(((item.Tariff>>0) & 0x01)===0x01);
               this.Permissions.tariff[1].Access=(((item.Tariff>>1) & 0x01)===0x01);
               this.Permissions.tariff[2].Access=(((item.Tariff>>2) & 0x01)===0x01);
               this.Permissions.tariff[3].Access=(((item.Tariff>>3) & 0x01)===0x01);
               this.Permissions.tariff[4].Access=(((item.Tariff>>4) & 0x01)===0x01);
               //bogs
               this.Permissions.bogs[0].Access=(((item.Bugs>>0) & 0x01)===0x01);
               this.Permissions.bogs[1].Access=(((item.Bugs>>1) & 0x01)===0x01);
               //violations
               this.Permissions.violations[0].Access=(((item.Violation>>0) & 0x01)===0x01);
               this.Permissions.violations[1].Access=(((item.Violation>>1) & 0x01)===0x01);
               
            },
            UpdatePermission(){
               //management
               var management=0;
               management|=(this.Permissions.management[0].Access)<<0;
               management|=(this.Permissions.management[1].Access)<<1;
               management|=(this.Permissions.management[2].Access)<<2;
               management|=(this.Permissions.management[3].Access)<<3;
               management|=(this.Permissions.management[4].Access)<<4;
               management|=(this.Permissions.management[5].Access)<<5;
               management|=(this.Permissions.management[6].Access)<<6;
               management|=(this.Permissions.management[7].Access)<<7;
               management|=(this.Permissions.management[8].Access)<<8;
               management|=(this.Permissions.management[9].Access)<<9;
               console.log(management)
               //online
               var online=0;
               online|=(this.Permissions.online[0].Access)<<0;
               online|=(this.Permissions.online[1].Access)<<1;
               online|=(this.Permissions.online[2].Access)<<2;
               online|=(this.Permissions.online[3].Access)<<3;
               online|=(this.Permissions.online[4].Access)<<4;
               //report
               var report=0;
               report|=(this.Permissions.report[0].Access)<<0;
               report|=(this.Permissions.report[1].Access)<<1;
               report|=(this.Permissions.report[2].Access)<<2;
               report|=(this.Permissions.report[3].Access)<<3;
               report|=(this.Permissions.report[4].Access)<<4;
               report|=(this.Permissions.report[5].Access)<<5;
               report|=(this.Permissions.report[6].Access)<<6;
               report|=(this.Permissions.report[7].Access)<<7;
               report|=(this.Permissions.report[8].Access)<<8;
               report|=(this.Permissions.report[9].Access)<<9;
               report|=(this.Permissions.report[10].Access)<<10;
               report|=(this.Permissions.report[11].Access)<<11;
               report|=(this.Permissions.report[12].Access)<<12;
               report|=(this.Permissions.report[13].Access)<<13;
            //Payment
            var pay=0;
            pay|=(this.Permissions.pay[0].Access)<<0;    
            pay|=(this.Permissions.pay[1].Access)<<1;    
            pay|=(this.Permissions.pay[2].Access)<<2;    
            pay|=(this.Permissions.pay[3].Access)<<3;    
            //security
            var security=0;
            security|=(this.Permissions.security[0].Access)<<0;    
            security|=(this.Permissions.security[1].Access)<<1;    
            security|=(this.Permissions.security[2].Access)<<2;    
            security|=(this.Permissions.security[3].Access)<<3; 
            //Tariff
            var tariff=0;
            tariff|=(this.Permissions.tariff[0].Access)<<0;    
            tariff|=(this.Permissions.tariff[1].Access)<<1;    
            tariff|=(this.Permissions.tariff[2].Access)<<2;    
            tariff|=(this.Permissions.tariff[3].Access)<<3; 
            tariff|=(this.Permissions.tariff[4].Access)<<4; 
            //bogs
            var bogs=0;
            bogs|=(this.Permissions.bogs[0].Access)<<0;   
            bogs|=(this.Permissions.bogs[1].Access)<<1;   
            //violations
            var violations=0;
            violations|=(this.Permissions.violations[0].Access)<<0;   
            violations|=(this.Permissions.violations[1].Access)<<1;   
            this.$store.commit('RulesPermission_Update',{
                RulesID:this.$route.query.RoleID,
                Admin:management,
                Bugs:bogs,
                Dashboard:255,
                Map:online,
                Payment:pay,
                Report:report,
                SecurtSettings:security,
                Tariff:tariff,
                Violation:violations
            });
        
        
        },
          CHeckAccess(type,index){
                return (((this.Permission[type]>>index) & 0x01)===0x01);
          }     
        }
    }
</script>

<style scoped>

</style>